import { render, staticRenderFns } from "./modalCreateProduct.vue?vue&type=template&id=5faf49b6"
import script from "./modalCreateProduct.vue?vue&type=script&lang=js"
export * from "./modalCreateProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports